export const timeOutRequest = 30000
export const version = 'v1'
export const VERSION_2 = 'v2'
export const VERSION_3 = 'v3'
export const VERSION_4 = 'v4'
export const VERSION_5 = 'v5'
export const baseURL = process.env.REACT_APP_BASE_URL
export const logURL = process.env.REACT_APP_LOG_URL
